<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('products')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="50"
      resource_url="/product/datatables"
      mode="grid"
      grid_class="is-col-min-10"
    >
      <template #item="item">
        <div class="card product-card">
          <div class="card-image has-text-centered" style="padding-top: 1rem">
            <figure
              class="image is-96x96 m-auto product-image"
              @click="edit(item)"
            >
              <v-lazy-image
                v-if="item.image"
                :src="`${api_host}/drive/static/${item.image}`"
              />
              <img
                v-else
                src="https://icon-library.com/images/product-icon-png/product-icon-png-11.jpg"
              />
            </figure>
            <div class="product-actions">
              <div class="field has-addons">
                <div class="control">
                  <button
                    class="button is-small"
                    :data-tooltip="$t('edit')"
                    @click.stop="edit(item)"
                  >
                    <span class="icon"
                      ><i class="fa fa-edit has-text-warning"></i
                    ></span>
                  </button>
                </div>
                <div class="control">
                  <button
                    class="button is-small"
                    :data-tooltip="$t('delete')"
                    @click.stop="remove(item)"
                  >
                    <span class="icon"
                      ><i class="fa fa-trash has-text-danger"></i
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-content px-2 py-3" @click="edit(item)">
            <div class="media">
              <div class="media-content">
                <div class="title is-6 has-text-centered mb-1">
                  {{ item.name }}
                </div>
                <div class="subtitle is-7 has-text-centered mb-2">
                  <span class="tag is-info is-medium">
                    {{ format_currency(item.sale_price) }}
                  </span>
                </div>
                <!-- <div
                  class="is-flex is-justify-content-center is-flex-wrap-wrap mb-2"
                >
                  <span
                    class="tag is-success mx-1"
                    v-if="item.available_for_sale"
                  >
                    <i class="fa fa-check mr-1"></i>
                    {{ $t("available for sale") }}
                  </span>
                  <span
                    class="tag is-warning mx-1"
                    v-if="item.is_inventariable"
                  >
                    <i class="fa fa-archive mr-1"></i>
                    {{ $t("is inventariable") }}
                  </span>
                  <span
                    class="tag is-info mx-1"
                    v-if="item.available_for_purchase"
                  >
                    <i class="fa fa-shopping-cart mr-1"></i>
                    {{ $t("available for purchase") }}
                  </span>
                </div> -->
                <div
                  class="has-text-grey is-size-7 has-text-centered"
                  v-if="item.barcode"
                >
                  <i class="fa fa-barcode mr-1"></i> {{ item.barcode }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </generic-table>

    <product-modal
      ref="product_modal"
      @success="refresh"
      :module_settings="module_settings"
    />
    <bulk-categorize-modal ref="bulk_categorize_modal" />
  </div>
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  api_host,
} from "@/utils";
import ProductModal from "./product_modal/Index.vue";
import BulkCategorizeModal from "./bulk_categorize_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "ProductsDatatable",
  components: { GenericTable, ProductModal, VLazyImage, BulkCategorizeModal },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    let v = this;
    return {
      api_host,
      extra_buttons: [
        {
          text: v.$t("bulk categorize"),
          icon: "fa fa-list",
          class: "is-secondary is-rounded",
          click: this.bulk_categorize,
        },
        {
          text: v.$t("add"),
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("barcode"),
          name: "barcode",
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.barcode || "";
          },
        },
        {
          title: v.$t("name"),
          name: "name",
          width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("sale price"),
          name: "sale_price",
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.sale_price) || "";
          },
        },
        {
          title: v.$t("availability"),
          searchable: false,
          width: "20%",
          data: (row) => {
            let r = "";

            let icon = "close";
            let _class = "has-text-danger";
            if (row.available_for_sale) {
              icon = "check";
              _class = "has-text-success";
            }
            r += `<span class="icon-text">
                    <span class="icon ${_class}">
                      <i class="fa fa-${icon}"></i>
                    </span>
                    <span>${v.$t("available for sale")}</span>
                  </span>`;

            icon = "close";
            _class = "has-text-danger";
            if (row.is_inventariable) {
              icon = "check";
              _class = "has-text-success";
            }
            r += `<span class="icon-text">
                      <span class="icon ${_class}">
                        <i class="fa fa-${icon}"></i>
                      </span>
                      <span>${v.$t("is inventariable")}</span>
                    </span>`;

            icon = "close";
            _class = "has-text-danger";
            if (row.available_for_purchase) {
              icon = "check";
              _class = "has-text-success";
            }
            r += `<span class="icon-text">
                    <span class="icon ${_class}">
                      <i class="fa fa-${icon}"></i>
                    </span>
                    <span>${v.$t("available for purchase")}</span>
                  </span>`;
            return r;
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.product_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete product?"),
                    v,
                    () => {
                      v.$root.loader(true);
                      del("/product", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        })
                        .finally(() => {
                          v.$root.loader(false);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.product_modal.show_modal();
    },
    bulk_categorize() {
      let v = this;
      v.$refs.bulk_categorize_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(item) {
      let v = this;
      v.$refs.product_modal.show_modal(item.uuid);
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete product?"),
        v,
        () => {
          v.$root.loader(true);
          del("/product", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        }
      );
    },
  },
  mounted() {
    let v = this;
    v.refresh();
    window.new_product = () => {
      v.create();
    };
  },
};
</script>

<style>
.product-card {
  transition: box-shadow 0.2s;
  box-shadow: 0 2px 12px rgba(44, 62, 80, 0.08);
  border-radius: 16px;
  margin-bottom: 1.5rem;
  cursor: pointer;
  position: relative;
}
.product-card:hover {
  box-shadow: 0 4px 24px rgba(44, 62, 80, 0.16);
}
.product-image img,
.product-image .v-lazy-image {
  border-radius: 12px;
  object-fit: cover;
  width: 96px;
  height: 96px;
  background: #14161a;
}
.product-actions {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  display: flex;
  gap: 0.5rem;
  z-index: 2;
}
.product-actions .button {
  opacity: 0.85;
  transition: opacity 0.2s;
}
.product-actions .button:hover {
  opacity: 1;
}
</style>
